import { ScreensizeContext } from "@pathwright/ui/src/components/ui/Screensize"
import { DROP_TYPE_PATH } from "@pathwright/web/src/modules/path/constants"
import classnames from "classnames"
import ConnectStores from "lib/core/store/components/ConnectStores"
import { DESIGN } from "path/constants"
import PropTypes from "prop-types"
import React from "react"
import { Draggable } from "react-beautiful-dnd"
import { withIsDragging } from "../../DragDropPathItems"
import PathListArchive from "../../manage/PathListArchive"
import PathTopicFormContainer from "../../manage/topic/PathTopicFormContainer"
import PathItemControls from "../PathItemControls"
import "./PathTopic.css"
import PathTopicDetails from "./PathTopicDetails"
import "./PathTopicEditor.css"

const PathTopicEditorDraggable = function (props) {
  const { mode, item } = props

  if (mode === DESIGN) {
    return (
      <Draggable
        type={DROP_TYPE_PATH}
        draggableId={item.id + ""}
        index={item.order - 1}
      >
        {(provided, snapshot) => {
          // Border prevents margin collapsing. Margin works better than padding.
          return (
            <div>
              <div
                {...Object.assign(
                  {
                    ref: provided.innerRef
                  },
                  provided.draggableProps
                )}
              >
                <div style={{ border: "1px solid transparent" }}>
                  <div style={{ margin: "19px 0" }}>
                    <ConnectedPathTopicEditor
                      {...Object.assign({}, props, {
                        dragHandleProps: provided.dragHandleProps,
                        isDragging: snapshot.isDragging
                      })}
                    />
                  </div>
                </div>
              </div>
              {provided.placeholder}
            </div>
          )
        }}
      </Draggable>
    )
  } else {
    return <ConnectedPathTopicEditor {...Object.assign({}, props)} />
  }
}

// PathTopicEditor concerns:
// - Connect drag & drop props
// - Determine view (normal, editing, archiving) from admin store selection

class PathTopicEditor extends React.Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.isDragging !== this.props.isDragging) {
      return true
    }
    if (nextProps.pathListIsDragging) {
      return false
    }
    if (nextContext.mode !== this.context.mode) {
      return true
    }
    if (nextProps.isEditing !== this.props.isEditing) {
      return true
    }
    if (nextProps.isArchiving !== this.props.isArchiving) {
      return true
    }
    if (JSON.stringify(nextProps.item) !== JSON.stringify(this.props.item)) {
      return true
    }
    return false
  }

  render() {
    const { item, isEditing, isArchiving, isDragging, dragHandleProps } =
      this.props

    const className = classnames(
      "PathTopicEditor",
      `PathTopicEditor--index-${item.order}`,
      { "PathTopicEditor--dragging": isDragging }
    )

    return (
      <ScreensizeContext.Consumer>
        {(screensize) => (
          <div className={className}>
            {isEditing ? (
              <PathTopicFormContainer actionLabel="Save" />
            ) : (
              <PathTopicDetails item={item} isArchiving={isArchiving} />
            )}
            {!isEditing && !isArchiving ? (
              <PathItemControls
                className="PathTopicEditor__controls"
                inlineControls={
                  screensize === "sm"
                    ? ["Move"]
                    : ["Edit", "Move", "Copy", "Archive"]
                }
                dropdownControls={
                  screensize === "sm" ? ["Edit", "Copy", "Archive"] : []
                }
                dragHandleProps={dragHandleProps}
                buttonStyles={{ inverted: true }}
                item={item}
              />
            ) : undefined}
            {isArchiving ? <PathListArchive item={item} /> : undefined}
          </div>
        )}
      </ScreensizeContext.Consumer>
    )
  }
}

PathTopicEditor.displayName = "PathTopicEditor"
PathTopicEditor.contextTypes = { mode: PropTypes.number }

const mapStateToProps = function (state, ownProps) {
  const { selection, editing_selection, archiving_selection } =
    state.pathAdminStore.state

  const isSelected = selection != null && selection.id === ownProps.item.id
  const isEditing = isSelected && editing_selection
  const isArchiving = isSelected && archiving_selection

  return _.assign(
    {},
    {
      isSelected,
      isEditing,
      isArchiving
    },
    ownProps
  )
}

const stores = [
  {
    store: "pathAdmin",
    watch: ["selection", "editing_selection", "archiving_selection"]
  }
]

var ConnectedPathTopicEditor = ConnectStores(
  PathTopicEditor,
  stores,
  {},
  mapStateToProps
)

export default withIsDragging(PathTopicEditorDraggable)
